import { render, staticRenderFns } from "./PayoutsDetails.vue?vue&type=template&id=54e0b6c0&scoped=true&"
import script from "./PayoutsDetails.vue?vue&type=script&lang=js&"
export * from "./PayoutsDetails.vue?vue&type=script&lang=js&"
import style0 from "./PayoutsDetails.vue?vue&type=style&index=0&id=54e0b6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e0b6c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCardSubtitle,VCardText,VCardTitle,VIcon,VSimpleTable})
